module.exports = __webpack_public_path__ + "media/src/assets/Images/Arrow-Right-Narrow-40c72fc2058b60f80470f68a0d3f195b.svg";